import { Navigate, Route, Routes } from "react-router-dom";
import AIConfigurationDetailPage from "./AIConfigurationDetailPage";
import { aiConfigurationPath } from "helpers/routePaths";

const AIConfiguration = () => (
	<Routes>
		<Route index element={<AIConfigurationDetailPage />} />
		<Route
			path=":id"
			element={<Navigate to={aiConfigurationPath} replace />}
		/>
	</Routes>
);

export default AIConfiguration;
